import { render, staticRenderFns } from "./LmsStudentBook.vue?vue&type=template&id=89b98dec&scoped=true"
import script from "./LmsStudentBook.vue?vue&type=script&lang=js"
export * from "./LmsStudentBook.vue?vue&type=script&lang=js"
import style0 from "./LmsStudentBook.vue?vue&type=style&index=0&id=89b98dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b98dec",
  null
  
)

export default component.exports